module.exports = __webpack_public_path__ + "static/seo-audits-b63380bcfb766796c2c07c80a68986b2.png";